// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GJYVDsiQMifDJrnw0cBU{min-height:16px;color:var(--content-primary-tertiary);gap:4px;margin-bottom:4px;padding:8px 0;display:flex}.GJYVDsiQMifDJrnw0cBU:last-of-type{margin-bottom:0}.sxGZZVC5XbU4kNOQA3qX{min-height:16px;padding:8px 4px 8px 12px;display:flex}.sxGZZVC5XbU4kNOQA3qX.his7OzHChYSTvfpAOBEA{flex-wrap:wrap;gap:8px 4px}.sxGZZVC5XbU4kNOQA3qX .ClppdrPavCApl_sHlKrn{gap:8px;display:flex}.wL0lYQ8GIQUGs3tj9wes{word-break:break-word;width:352px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `GJYVDsiQMifDJrnw0cBU`,
	"value": `sxGZZVC5XbU4kNOQA3qX`,
	"triggerValue": `his7OzHChYSTvfpAOBEA`,
	"row": `ClppdrPavCApl_sHlKrn`,
	"textValue": `wL0lYQ8GIQUGs3tj9wes`
};
export default ___CSS_LOADER_EXPORT___;
